import { Navigate, Route, Routes } from 'react-router-dom';
import { Home } from '../pages/Home';
import { Setup } from '../pages/Setup';
import { Rules } from '../pages/Rules';
import { GamePage } from '../pages/GamePage';
import { Room } from '../pages/Room';
import { Join } from '../pages/Join';
import { NotFound } from '../pages/NotFound';
import { ToastViewport } from '../components/Toast';

export function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/setup/:mode" element={<Setup />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/play/local" element={<GamePage mode="local" />} />
        <Route path="/play/ai" element={<GamePage mode="ai" />} />
        <Route path="/room/:code" element={<Room />} />
        <Route path="/join/:code" element={<Join />} />
        <Route path="/setup" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ToastViewport />
    </>
  );
}
